module.exports = __webpack_public_path__ + "static/media/img-benefit-applewatch-2-mobile.f557eba7.png";